import { render, staticRenderFns } from "./edit-review-category-modal.vue?vue&type=template&id=94fc91f0&scoped=true"
import script from "./edit-review-category-modal.vue?vue&type=script&lang=js"
export * from "./edit-review-category-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fc91f0",
  null
  
)

export default component.exports